<app-vertical />
@if (mostrarTermos()) {
  <app-termos-condicoes />
} @else if (mostrarConfidencialidade()) {
  <app-termo-confidencialidade />
}
